export enum Status {
    Error = 0,
    Success = 1,
    Warning = 2
}